import { lazy } from 'react';

export const GalleryLazy = lazy(() => import('./Gallery'));
